module.exports = "<nav class=\"nav-tabs\">\n  <ul>\n    <li><a ui-sref=\"store.register\" ui-sref-active=\"active\" ui-sref-active-eq class=\"icon-store\">Punti vendita</a></li>\n    <!-- <li><a ui-sref=\"shop.beacon\" ui-sref-active=\"active\" ui-sref-active-eq class=\"icon-beacon\">Beacon</a></li> -->\n  </ul>\n</nav>\n\n<div class=\"nav-tabs-contents\">\n  <div class=\"page-content\" ui-view></div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/store/store.html
 ** module id = 455
 ** module chunks = 0
 **/